import React from 'react';

import { dotFormatter } from '../../../../../helpers/number';
import { useTranslation } from '../../../../../hooks';
import { T } from '../../../../../constants';

interface SidebarCardProps {
  className?: string;
  title: string;
  amount: number;
  currencyCode: string;
  onDetailsClick?: () => void;
  winnersLabel?: string;
  children?: React.ReactNode;
  extraInfo?: React.ReactNode;
  winnersValue?: number | string;
}

export const SidebarCard: React.FC<SidebarCardProps> = ({
  className = '',
  title,
  amount,
  currencyCode,
  onDetailsClick,
  winnersLabel,
  winnersValue,
  children,
  extraInfo,
}) => {

  const t = useTranslation();

  return (
    <div className={`boosted-jackpot-block ${className}`} onClick={onDetailsClick}>
      <div className="new-jackpot-block-header">
        <span className="new-jackpot-header-text">{title}</span>
          <button className="details-btn-new" type="button">{t(T.DETAILS)}</button>
      </div>
      <div className="boosted-jackpot-duration">
        {children}
      </div>
      <p className="jackpot-nsp-text">{dotFormatter(amount)} {currencyCode}</p>
      {extraInfo}
      {winnersLabel && (
        <div className="winners-count">
          <p className="winners-count-text-jackpot">{winnersLabel}</p>
          <p className="winners-count-number-jackpot">{winnersValue}</p>
        </div>
      )}
    </div>
  );
};
